import { render, staticRenderFns } from "./ModalManualShipped.vue?vue&type=template&id=5c1b0de5&scoped=true&"
import script from "./ModalManualShipped.vue?vue&type=script&lang=js&"
export * from "./ModalManualShipped.vue?vue&type=script&lang=js&"
import style0 from "./ModalManualShipped.vue?vue&type=style&index=0&id=5c1b0de5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b0de5",
  null
  
)

export default component.exports